import {
    getRoles, getUsers, getCompany, getTenant, getCustomer, createUsers, editUser, updateStatusUser, getDestTypes, getClidTypes,
    getLocation, getLocationById, getCustomerById, postLocation, DeleteLocationById, editLocation, getstrategyType, deleteUser,
    createBulkEndUsers, editBulkEndUser, deleteBulkEndUser, resetUserPassword
  } from "../service/api";
  
  export const ActionRolesList = () => async (dispatch) => {
    await getRoles().then(function (value) {     
      dispatch({
        type: "ROLE_LIST",
        payload: value,
      });
    });
  };

export const ActionUserList = () => async (dispatch) => {
    await getUsers().then(function (value) {    
      dispatch({
        type: "USER_LIST",
        payload: value,
      });
    });
  };

  export const ActionGetCompany = () => async (dispatch) => {
    await getCompany().then(function (value) {
   
      dispatch({
        type: "COMPANY_LIST",
        payload: value,
      });
    });
  };
  export const ActionGetTenant = () => async (dispatch) => {
    await getTenant().then(function (value) {
  
      dispatch({
        type: "TENANT_LIST",
        payload: value,
      });
    });
  };
  export const ActionGetCustomer = () => async (dispatch) => {
    await getCustomer().then(function (value) {
      dispatch({
        type: "CUSTOMER_LIST",
        payload: value,
      });
    });
  };

  export const ActionCustomerById = (id) => async (dispatch) => {
    await getCustomerById(id).then(function (value) {
      dispatch({
        type: "CUSTOMER_SINGLE",
        payload: value,
      });
    });
  };
  export const ActionCreateUser = (data, callback) => async (dispatch) => {
    await createUsers(data).then(function (value) {
      dispatch({
        type: "CREATE_USER",
        payload: value,
      });
      callback();
    });
  };

  export const ActionUpdateUser =
  (uid, data, callback) => async (dispatch) => {
    await editUser(uid, data).then(function (value) {
      dispatch({
        type: "UPDATE_USER",
        payload: value,
      });
      callback();
    });
  };
  export const ActionUpdateStatusUser =
  (uid, data, callback) => async (dispatch) => {
    await updateStatusUser(uid, data).then(function (value) {
      dispatch({
        type: "UPDATE_STATUS_USER",
        payload: value,
      });
      callback();
    });
  };

  export const ActionDeleteCompany =
  (id, callback) => async (dispatch) => {
    await deleteUser(id).then(function (value) {
      dispatch({
        type: "DELETE_COMPANY",
        payload: value,
      });
      callback();
    });
  };
  export const ActionDeleteTenant =
  (id, callback) => async (dispatch) => {
    await deleteUser(id).then(function (value) {
      dispatch({
        type: "DELETE_TENANT",
        payload: value,
      });
      callback();
    });
  };
  
  export const ActionDeleteEndUser =
  (id, callback) => async (dispatch) => {
    await deleteUser(id).then(function (value) {
      dispatch({
        type: "DELETE_ENDUSER",
        payload: value,
      });
      callback();
    });
  };


  //ACTION DEST TYPE
  export const ActionGetDestType = () => async (dispatch) => {
    await getDestTypes().then((values) => {
      dispatch({
        type: "DEST_TYPE",
        payload: values,
      });
      return values;
    });
  };
 
  //ACTION CLID TYPE
  export const ActionGetClidType = () => async (dispatch) => {
    await getClidTypes().then((values) => {
      dispatch({
        type: "CLID_TYPE",
        payload: values,
      });
      return values;
    });
  };

   //ACTION STRATEGY Type
   export const ActionStrategyType = () => async (dispatch) => {
    await getstrategyType().then((values) => {
      dispatch({
        type: "STRATEGY",
        payload: values,
      });
      return values;
    });
  };

   //ACTION LOCATION
   export const ActionGetLocation = () => async (dispatch) => {
    await getLocation().then((values) => {
      dispatch({
        type: "LOCATION",
        payload: values,
      });
      return values;
    });
  };
  export const ActionLocationById = (id) => async (dispatch) => {
    await getLocationById(id).then(function (value) {
      dispatch({
        type: "LOCATION_SINGLE",
        payload: value,
      });
    });
  };
  export const ActionDeleteLocation =
    (id, callback) => async (dispatch) => {
      await DeleteLocationById(id).then(function (value) {
        dispatch({
          type: "DELETE_LOCATION",
          payload: value,
        });
        callback();
      });
    };
  
  export const ActionUpdateLocation =
    (uid, data, callback) => async (dispatch) => {
      await editLocation(uid, data).then(function (value) {
        dispatch({
          type: "UPDATE_LOCATION",
          payload: value,
        });
        callback();
      });
    };
  
  export const ActionCreateLocation =
    (data, callback) => async (dispatch) => {
      await postLocation(data).then(function (value) {
        dispatch({
          type: "CREATE_LOCATION",
          payload: value,
        });
        callback();
      });
    };


   // BULK ENDUSER 

  //  export const ActionCreateBulkEndUser = (data, callback) => async (dispatch) => {
  //   await createBulkEndUsers(data).then(function (value) {
  //     console.log("value", value);
  //     dispatch({
  //       type: "CREATE_BULK_ENDUSER",
  //       payload: value,
  //     });
  //     callback();
  //   });
  // };

  export const ActionCreateBulkEndUser = (data, callback) => async (dispatch) => {
    try {
      const value = await createBulkEndUsers(data);
      dispatch({
        type: "CREATE_BULK_ENDUSER",
        payload: value,
      });
      if (callback) callback();
      return value;
    } catch (error) {
      if (error.response) {
      } else if (error.request) {
      } else {
      }
      throw error.response ? error.response.data : error;
    }
  };
  
  
  export const ActionUpdateBulkEndUser =
  (data, callback) => async (dispatch) => {
    await editBulkEndUser(data).then(function (value) {
      dispatch({
        type: "UPDATE_BULK_ENDUSER",
        payload: value,
      });
      callback();
    });
  };

  export const ActionDeleteBulkEndUser =
  (data, callback) => async (dispatch) => {
    await deleteBulkEndUser(data).then(function (value) {
      dispatch({
        type: "DELETE_BULK_ENDUSER",
        payload: value,
      });
      callback();
    });
  };

  export const ActionResetPasswordUser =
  (data, callback) => async (dispatch) => {
    await resetUserPassword(data).then(function (value) {
      dispatch({
        type: "RESET_PASSWORD_USER",
        payload: value,
      });
      callback();
    });
  };

